import {
  Button,
  CircularProgress,
  Divider,
  IconButton,
  Paper,
  Switch,
  Table,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { useForm } from "react-hook-form";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { CustomFormField } from "../../../utilis/component/CustomFormElement";
import { useLocation, useNavigate } from "react-router-dom";
import { ChangeEvent, useEffect, useRef, useState } from "react";
import {
  initialFormData,
  InsurancePlanType,
  MasterFormDataType,
  MasterTableDataType,
} from "./Types";
import usePopup from "../../../hooks/usePopup";
import { useMutation, useQuery } from "react-query";
import { deleteInsurancepalnid, saveMasterData } from "./service";
import { clinicId } from "../../../constants";
import { FormOnChangeEventType } from "../../../EMR/types";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import CheckIcon from "@mui/icons-material/Check";
import EditIcon from "@mui/icons-material/Edit";
import {
  getInsuranceType,
  getInsuranceByParams,
} from "../../../Insurance/services";
import useAuthentication from "@hooks/useAuthentication";
import CustomTableBody from "@utilifiles/component/CustomTableBody";
const pageTitle = "Insurance Plan";
export const storageKey = "PlainIds";
function InsurancePlanAddOrEditPage() {
  const navigate = useNavigate();
  const { user } = useAuthentication();
  const { showSnackbar } = usePopup();
  const planIdRef = useRef<number | null>(null);
  const [planList, setPlanList] = useState<InsurancePlanType[]>([]);
  const [isError, setIsError] = useState(false);
  const [edit, setEdit] = useState<
    (InsurancePlanType & { index: number; isEdit?: boolean }) | null
  >(null);

  const planObj: InsurancePlanType = {
    inPlanCreateById: Number(user?.login_id),
    planId: 0,
    planCode: "",
    planName: "",
    planStatus: 1,
  };
  const { control, handleSubmit, reset, setValue, watch } =
    useForm<MasterFormDataType>({
      defaultValues: initialFormData,
    });
  const {
    state: { data = null },
  } = useLocation() as { state: { data: MasterTableDataType } };
  const handleGoBack = () => {
    navigate(-1);
  };
  const [insType, setInsType] = useState<number | null>(null);

  const { data: InsuranceTypeList, isLoading: InsuranceTypeListLoading } =
    useQuery(["insuranceTypesForPlanMaster"], getInsuranceType, {
      refetchOnWindowFocus: false,
    });

  const { mutate: deletePlan, isLoading: deleteLoading } = useMutation(
    deleteInsurancepalnid,
    {
      onSuccess: (result) => {
        if (result.responseIndicator == "success") {
          showSnackbar({
            message: result.responseMessage,
            open: true,
            variant: "success",
            duration: 3000,
          });
          const updated = planList.filter((p) => p.planId != planIdRef.current);
          setPlanList(updated);
        } else {
          showSnackbar({
            message: result.responseMessage,
            open: true,
            variant: "warning",
            duration: 3000,
          });
        }
      },
      onError: (e: any) => {
        showSnackbar({
          message:
            e?.response?.data?.responseMessage || "Something went wrong !",
          open: true,
          variant: "error",
          duration: 3000,
        });
      },
    }
  );

  const { mutate: getInsuranceByType, data: ReceiverList } =
    useMutation(getInsuranceByParams);

  const { mutate: getInsuranceByType2, data: PayerList } =
    useMutation(getInsuranceByParams);

  const { mutate: save, isLoading } = useMutation(saveMasterData, {
    onSuccess: (result) => {
      if (result.responseIndicator == "success") {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "success",
          duration: 3000,
        });
        handleGoBack();
      } else {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "warning",
          duration: 3000,
        });
      }
    },
    onError: (e: any) => {
      showSnackbar({
        message: e?.response?.data?.responseMessage || "Something went wrong !",
        open: true,
        variant: "error",
        duration: 3000,
      });
    },
  });
  const onSubmit = (value: MasterFormDataType) => {
    if (Boolean(planList.length)) {
      save([
        {
          clinicId: Number(clinicId),
          inGroupId: value?.inGroup?.id ?? null,
          inNameId: value?.insurance?.id ?? null,
          inPlanCreateById: Number(user?.userId),
          inPlanCode: value?.inPlanCode as string,
          inTypeId: value?.insType?.id ?? null,
          inPlanStatus: data?.inPlanStatus as number,
          inPlanName: planList,
        },
      ]);
    } else {
      showSnackbar({
        message: "Please add insurance plans",
        open: true,
        variant: "warning",
        duration: 3000,
      });
    }
  };

  const OnTypeChange = (e: FormOnChangeEventType) => {
    const value = e?.target?.value;
    setInsType(value?.id);
    getInsuranceByType({ typeId: value.id });
    const allValues = watch();
    reset({
      ...allValues,
      insurance: null,
      inGroup: null,
    });
  };
  const ReceiverChange = () => {
    getInsuranceByType2({ typeId: 2 });
    const allValues = watch();
    reset({
      ...allValues,
      inGroup: null,
    });
  };

  const handleAddPlan = () => {
    setPlanList((pre) => [planObj, ...pre]);
    setEdit({ ...planObj, index: 0 });
  };

  const handleDelete = (id: number, index: number) => {
    planIdRef.current = id;
    if (data && id > 0) {
      deletePlan({ clinicId: Number(user?.clinicId), inPlanId: id });
    } else {
      const updated = planList.filter((_, i) => i != index);
      setPlanList(updated);
    }
    setEdit(null);
  };

  const handleEdit = (item: InsurancePlanType & { index: number }) => {
    setIsError(false);
    setEdit({ ...item, isEdit: true });
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const field = e.target.dataset.field as keyof typeof edit;
    const index = Number(e.target.dataset.index);
    setIsError(false);
    if (edit) {
      field == "planStatus"
        ? setEdit({ ...edit, [field]: e.target.checked ? 1 : 0 })
        : setEdit({ ...edit, [field]: e.target.value });
    } else {
      field == "planStatus"
        ? setEdit({
            ...planObj,
            [field]: e.target.checked ? 1 : 0,
            index,
          })
        : setEdit({
            ...planObj,
            [field]: e.target.value,
            index,
          });
    }
  };

  const handleSaveList = () => {
    const isData = planList.find((i) => i?.planCode == edit?.planCode);
    if (!Boolean(edit?.planCode) || !Boolean(edit?.planName)) {
      setIsError(true);
      return;
    }
    if (isData && !Boolean(edit?.isEdit)) {
      showSnackbar({
        message: `${edit?.planCode} already exist !`,
        open: true,
        variant: "info",
        duration: 3000,
      });
    } else {
      if (edit) {
        const updated = [...planList];
        updated[edit?.index] = edit;
        setPlanList(updated);
      }
      setEdit(null);
    }
  };

  const onStatusChange = (e: FormOnChangeEventType) => {
    const { target } = e;
    const updated = planList.map((p) => ({
      ...p,
      planStatus: Number(target?.value),
    }));
    setPlanList(updated);
    edit && setEdit({ ...edit, planStatus: Number(target?.value) });
  };

  const handleReset = () => {
    if (data) {
      reset({
        insType: data?.insuranceType?.insTypeId
          ? {
              id: data?.insuranceType?.insTypeId,
              name: data?.insuranceType?.insuranceTypeName,
            }
          : null,
        insurance: data?.insurance?.insuranceNameId
          ? {
              id: data?.insurance?.insuranceNameId as number,
              name: data?.insurance?.insuranceName as string,
            }
          : null,
        inGroup: data?.inGroup?.inGroupId
          ? {
              id: data?.inGroup?.inGroupId as number,
              name: data?.inGroup?.inGroupName as string,
            }
          : null,
        status: data?.inPlanStatus,
      });

    const allPlans = data.inPlan.map((p) => {
        return {
          ...p,
          planStatus:data?.inPlanStatus,
          inPlanCreateById: Number(user?.login_id),
        };
      });
      setPlanList(allPlans);
    } else {
      reset({
        insType: null,
        insurance: null,
        inGroup: null,
        inPlan: "",
        inPlanCode: "",
        status: 1,
      });
      setPlanList([]);
    }
  };

  useEffect(() => {
    if (data) {
      console.log(data);
      data?.insuranceType?.insTypeId == 1
        ? (setInsType(1),
          getInsuranceByType({ typeId: 1 }),
          getInsuranceByType2({ typeId: 2 }))
        : getInsuranceByType({ typeId: 2 });

      reset({
        insType: data?.insuranceType?.insTypeId
          ? {
              id: data?.insuranceType?.insTypeId,
              name: data?.insuranceType?.insuranceTypeName,
            }
          : null,
        // inPlan: data?.inPlan?.inPlanName,
        // inPlanCode: data?.inPlanCode,
        status: data?.inPlanStatus,
      });

      data?.insurance?.insuranceNameId &&
        setValue("insurance", {
          id: data?.insurance?.insuranceNameId as number,
          name: data?.insurance?.insuranceName as string,
        });

      data?.inGroup?.inGroupId &&
        setValue("inGroup", {
          id: data?.inGroup?.inGroupId as number,
          name: data?.inGroup?.inGroupName as string,
        });
      const allPlans = data.inPlan.map((p) => {
        return {
          ...p,
          inPlanCreateById: Number(user?.login_id),
        };
      });
      setPlanList(allPlans as InsurancePlanType[]);
    }
  }, [data]);

  return (
    <div className="p-3 ">
      <form onSubmit={handleSubmit(onSubmit)}>
        <Paper>
          <div className="flex justify-between items-center p-2">
            <div>
              <Typography variant="h6" className="p-3">
                Add {pageTitle}
              </Typography>
            </div>
            <div className="flex gap-2">
              <Button
                variant="outlined"
                startIcon={<ArrowBackIcon />}
                onClick={handleGoBack}
              >
                back
              </Button>
              <Button
                disabled={isLoading}
                color="error"
                type="reset"
                startIcon={<CloseIcon />}
                onClick={handleReset}
              >
                reset
              </Button>
              <Button
                disabled={isLoading}
                type="submit"
                color="success"
                startIcon={
                  isLoading ? (
                    <CircularProgress size={20} color="success" />
                  ) : (
                    <SaveIcon />
                  )
                }
              >
                save
              </Button>
            </div>
          </div>
          <Divider />
          <div className="p-3 grid grid-cols-4 gap-3">
            <CustomFormField
              control={control}
              name="insType"
              element="autocomplete"
              loading={InsuranceTypeListLoading}
              fieldProps={{ label: "InsuranceType" }}
              rules={{
                required: "Insurance is required",
                onChange: OnTypeChange,
              }}
              autocompleteProps={{
                isOptionEqualToValue: (option, value) =>
                  option?.id == value?.id,
                getOptionLabel: (option) => option?.name,
              }}
              options={InsuranceTypeList?.response || []}
            />

            <CustomFormField
              control={control}
              name="insurance"
              element="autocomplete"
              fieldProps={{ label: "Receiver" }}
              rules={{
                required: "Receiver is required",
                onChange: ReceiverChange,
              }}
              options={ReceiverList?.response || []}
              autocompleteProps={{
                isOptionEqualToValue: (option, value) =>
                  option?.id == value?.id,
                getOptionLabel: (option) => option?.name,
              }}
            />
            {insType == 1 && (
              <CustomFormField
                control={control}
                name="inGroup"
                element="autocomplete"
                fieldProps={{ label: "Payer" }}
                rules={{ required: false }}
                options={PayerList?.response || []}
                autocompleteProps={{
                  isOptionEqualToValue: (option, value) =>
                    option?.id == value?.id,
                  getOptionLabel: (option) => option?.name,
                }}
              />
            )}

            <CustomFormField
              control={control}
              name="status"
              element="radio"
              radioProps={{ row: true }}
              radios={[
                { label: "Active", value: 1 },
                { label: "Inactive", value: 0 },
              ]}
              fieldProps={{ label: "Status " }}
              rules={{
                required: "Plan status is required",
                onChange: onStatusChange,
              }}
            />

            <div className="col-span-full border-2 rounded">
              <div className="flex justify-between border-b p-2">
                <Typography fontWeight={500}>Add plans</Typography>
                <Button
                  disabled={Boolean(edit)}
                  color="success"
                  endIcon={<AddIcon />}
                  onClick={handleAddPlan}
                >
                  Add
                </Button>
              </div>
              <div className="">
                <Table size="small">
                  <TableHead>
                    <TableCell>Code</TableCell>
                    <TableCell>Name</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Action</TableCell>
                  </TableHead>
                  <CustomTableBody
                    alert={"No plans"}
                    dataLoading={false}
                    isData={Boolean(planList?.length)}
                    totalSpan={{ row: 5, col: 3 }}
                  >
                    {planList?.map((plan, index) => {
                      return edit?.index == index ? (
                        <TableRow>
                          <TableCell width={200}>
                            <TextField
                              fullWidth
                              label="Enter code"
                              value={edit?.planCode}
                              inputProps={{
                                "data-field": "planCode",
                                "data-index": index,
                                readOnly: Boolean(edit.planId == plan.planId && plan.planId != 0)
                              }}
                              onChange={handleChange}
                              error={isError && !Boolean(edit.planCode)}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              
                              fullWidth
                              label="Enter name"
                              value={edit?.planName}
                              inputProps={{ "data-field": "planName",readOnly: Boolean(edit.planId == plan.planId && plan.planId != 0),  }}
                              onChange={handleChange}
                              error={isError && !Boolean(edit.planName)}
                            />
                          </TableCell>
                          <TableCell>
                            <Switch
                              checked={Boolean(edit?.planStatus)}
                              inputProps={
                                {
                                  "data-field": "planStatus",
                                } as React.InputHTMLAttributes<HTMLInputElement>
                              }
                              onChange={handleChange}
                            />
                          </TableCell>
                          <TableCell>
                            <div className="flex justify-start items-center gap-2">
                              <IconButton
                                color="success"
                                onClick={handleSaveList}
                              >
                                <CheckIcon />
                              </IconButton>
                              <IconButton
                                disabled={deleteLoading}
                                color="error"
                                onClick={() => {
                                  handleDelete(Number(plan.planId), index);
                                }}
                              >
                                {deleteLoading &&
                                plan.planId == planIdRef.current ? (
                                  <CircularProgress color="error" size={18} />
                                ) : (
                                  <DeleteIcon />
                                )}
                              </IconButton>
                            </div>
                          </TableCell>
                        </TableRow>
                      ) : (
                        <TableRow>
                          <TableCell width={200}>{plan.planCode}</TableCell>
                          <TableCell>{plan.planName}</TableCell>
                          <TableCell>
                            {plan.planStatus ? (
                              <Typography color="success">Active</Typography>
                            ) : (
                              <Typography color="error">Inactive</Typography>
                            )}
                          </TableCell>
                          <TableCell>
                            <div className="flex justify-start items-center gap-2">
                              <IconButton
                                disabled={Boolean(edit)}
                                color="primary"
                                onClick={() => {
                                  handleEdit({ ...plan, index });
                                }}
                              >
                                <EditIcon />
                              </IconButton>
                              <IconButton
                                disabled={deleteLoading}
                                color="error"
                                onClick={() => {
                                  handleDelete(Number(plan.planId), index);
                                }}
                              >
                                {deleteLoading &&
                                plan.planId == planIdRef.current ? (
                                  <CircularProgress color="error" size={18} />
                                ) : (
                                  <DeleteIcon />
                                )}
                              </IconButton>
                            </div>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </CustomTableBody>
                </Table>
              </div>
            </div>
          </div>
        </Paper>
      </form>
    </div>
  );
}

export default InsurancePlanAddOrEditPage;
